import EmcdPuzzleService from "./challenges/emcd/puzzle";
import CaptchaV3HideService from "./challenges/google/v3-hide";
class Challenge {
  async check({ challenge = null, challengeData, node, context }) {
    if (challenge === "v3-hide") {
      return CaptchaV3HideService.check();
    }
    if (challenge === "emcd-puzzle") {
      const { image, part } = challengeData;

      if (!image || !part) {
        return Promise.reject("need image & part from api");
      }
      return EmcdPuzzleService.check({
        node,
        pictureBlob: image,
        partBlob: part,
        context,
      });
    }
  }
}
const ChallengeService = new Challenge();

export default ChallengeService;
